import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Заявка на лизинг',
  subtitle: 'Выберите, кому отправить заявку, и укажите, как с вами связаться',
  forAgrariansOnly: 'Доступно только для аграриев',
  products: {
    titles: {
      alfaLeasing: 'Альфа-Лизинг',
      interleasingLeasing: 'Интерлизинг',
      baltiyskiyLeasing: 'Балтийский Лизинг',
      vtbLeasing: 'ВТБ Лизинг',
      rosAgroLeasing: 'РосАгроЛизинг',
      stoneXxiLeasing: 'СТОУН-XXI',
      sberLeasing: 'СберЛизинг',
      fleetFinanceLeasing: 'Fleet Finance',
    },
  },
} satisfies TMessages
